// **Author:** Nagaraj
import React, { useEffect, useState } from "react";
import styles from "./AccountDetails.module.css";
import {
  Container,
  Typography,
  Box,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const AccountDetails = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch("http://localhost:3001/customers/1")
      .then((res) => {
        if (res.status === 404) {
          // Try to fetch the first customer in the list as fallback
          return fetch("http://localhost:3001/customers")
            .then((r) => r.json())
            .then((arr) => arr[0] || null);
        }
        if (!res.ok) throw new Error("Failed to fetch account details");
        return res.json();
      })
      .then((json) => {
        if (!json) throw new Error("No account found.");
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Container className={styles.wrapper} sx={{ textAlign: "center", py: 8 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error || !data) {
    return (
      <Container className={styles.wrapper} sx={{ textAlign: "center", py: 8 }}>
        <Typography color="error">{error || "No data found."}</Typography>
      </Container>
    );
  }

  return (
    <Container className={styles.wrapper}>
      <Box className={styles.header}>
        <Button variant="outlined" onClick={() => navigate("/admin/beneficiaries")}>
          View Beneficiaries
        </Button>
        <Button variant="contained" color="primary" onClick={() => navigate("/admin/transfer")}>
          Fund Transfer
        </Button>
      </Box>

      <Typography variant="h5" className={styles.title}>
        Account Details
      </Typography>

      <Box component={Paper} elevation={3} className={styles.formBox}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <TextField label="Name" value={data.name} fullWidth size="small" InputProps={{ readOnly: true }} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField label="Type" value={data.accountType} fullWidth size="small" InputProps={{ readOnly: true }} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField label="Email ID" value={data.email} fullWidth size="small" InputProps={{ readOnly: true }} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField label="Phone" value={data.phone} fullWidth size="small" InputProps={{ readOnly: true }} />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              label="Account No."
              value={data.accountNumber}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              label="Creation Date"
              value={new Date(data.accountCreationDate).toLocaleDateString()}
              fullWidth
              size="small"
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </Box>

      <Typography variant="h6" className={styles.tableTitle}>
        Last 10 Transactions
      </Typography>

      <TableContainer component={Paper} elevation={2}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976d2" }}>
            <TableRow>
              <TableCell sx={{ color: "white" }}>Transaction Date</TableCell>
              <TableCell sx={{ color: "white" }}>Transaction Type</TableCell>
              <TableCell sx={{ color: "white" }}>Amount</TableCell>
              <TableCell sx={{ color: "white" }}>Remarks</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data.transactions && data.transactions.length > 0
              ? data.transactions
              : [
                  {
                    transactionDate: "2024-06-01T09:00:00Z",
                    transactionType: "CR",
                    amount: 5000,
                    remarks: "Salary",
                  },
                  {
                    transactionDate: "2024-05-28T14:00:00Z",
                    transactionType: "DR",
                    amount: 1200,
                    remarks: "Groceries",
                  },
                  {
                    transactionDate: "2024-05-25T10:00:00Z",
                    transactionType: "DR",
                    amount: 2000,
                    remarks: "Rent",
                  },
                  {
                    transactionDate: "2024-05-20T16:00:00Z",
                    transactionType: "DR",
                    amount: 800,
                    remarks: "Transfer",
                  },
                  {
                    transactionDate: "2024-05-18T11:00:00Z",
                    transactionType: "CR",
                    amount: 1500,
                    remarks: "Refund",
                  },
                ]
            ).map((tx, index) => (
              <TableRow key={index}>
                <TableCell>{new Date(tx.transactionDate).toLocaleDateString()}</TableCell>
                <TableCell>
                  <Chip
                    label={tx.transactionType}
                    color={tx.transactionType === "CR" ? "success" : "error"}
                    size="small"
                  />
                </TableCell>
                <TableCell>₹{tx.amount}</TableCell>
                <TableCell>{tx.remarks}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Note: Data fetched from json-server (mock API)
      </Typography>
    </Container>
  );
};

export default AccountDetails;
